const BLOCK_TYPE_GROUPS = [
  { label: 'Find File', values: new Set(['data_find_file', 'data find file', 'find file']) },
  { label: 'Form', values: new Set(['data_form', 'data form', 'form']) },
  { label: 'Result', values: new Set(['data_rpa', 'data rpa', 'result']) },
  { label: 'Text', values: new Set(['data_ev', 'data ev', 'text']) },
  { label: 'API', values: new Set(['api']) },
  { label: 'Select File', values: new Set(['data', 'select file']) },
]

const PLAY_TYPE_LABELS = {
  unfixed: '인풋 데이터',
  master: '마스터파일',
  fixed: '고정 데이터',
}

function normalize(value) {
  return String(value ?? '').trim().toLowerCase().replace(/[-]+/g, ' ')
}

export function rpaInputBlockTypeLabel(field = {}) {
  const rawValues = [field.activity_type, field.block_type, field.type, field.input_type]
    .filter(value => String(value ?? '').trim())
  const types = rawValues.map(normalize)
  const group = BLOCK_TYPE_GROUPS.find(entry => types.some(type => entry.values.has(type)))
  if (group) return group.label
  if (types.includes('file')) return 'Select File'
  return String(rawValues[0] ?? '').trim() || 'Input'
}

export function rpaInputBlockName(field = {}) {
  return [field.edited_name, field.activity_name, field.label, field.name]
    .map(value => String(value ?? '').trim())
    .find(Boolean) || rpaInputBlockTypeLabel(field)
}

export function rpaInputDisplayName(field = {}) {
  const label = rpaInputBlockName(field)
  const activityId = String(field.activity_id ?? '').trim()
  if (!activityId) return label
  const suffix = ` ${activityId}`
  const withoutId = label === activityId
    ? ''
    : label.endsWith(suffix) ? label.slice(0, -suffix.length).trim() : label
  return withoutId || rpaInputBlockTypeLabel(field)
}

export function rpaInputPlayTypeLabel(value) {
  const raw = String(value ?? '').trim()
  return PLAY_TYPE_LABELS[normalize(raw) || 'unfixed'] || raw
}
